<template>
  <div class="page source-page">
    <div class="page-header">
      <img v-if="bannerImage" class="page-header__banner" :src="bannerImage" alt="banner">
      <img v-else class="page-header__banner" src="~@/assets/images/speciality-header.png" alt="banner">
      <div class="page-header__bd">
        <h1 class="page-name">{{ $route.meta.title }}</h1>
        <div class="page-search">
          <el-input class="page-searchInput" v-model.trim="name"
                           placeholder="请输入查询内容">
          </el-input>
          <el-button class="page-searchButton" @click="submit()">查询</el-button>
        </div>
      </div>
    </div>
    <div class="page-bd">
      <div class="">
        <el-row style="margin-bottom: 15px;" type="flex">
          <el-tabs class="ui-tabs" v-model="sourceType" @tab-click="onChangeSourceType" style="width: 100%;">
            <el-tab-pane label="专业访谈" name="1"></el-tab-pane>
            <el-tab-pane label="职业访谈" name="2"></el-tab-pane>
            <el-tab-pane label="经典案例" name="3"></el-tab-pane>
            <el-tab-pane label="升学资料" name="4"></el-tab-pane>
          </el-tabs>
        </el-row>
        <div v-loading="tabs.sourceTypeLoading" class="">
          <el-empty v-show="tabs.list.length === 0"
                    :description="tabs.sourceTypeLoading ? '加载中...' : '暂无数据'"></el-empty>

          <div class="image-gallery">
            <div class="image-wrapper" v-for="item in tabs.list" @click="goDetails(item)">
              <img :src="item.imageUrl" :alt="item.name">
              <div class="image-title">{{item.name}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {request} from "@/util/request.js"

export default {
  data() {
    return {
      bannerImage: null,
      sourceType: '1', // 资源类型  专业访谈:1 职业访谈:2 经典案例:3 升学资料:4
      tabs: {
        list: [],
        active: null,
        sourceTypeLoading: false,
      },
      majors: [],
      searchhead: 0,
      name: null,
    }
  },
  created() {
    this.getBanner()
    this.getSourceType()
  },
  mounted() {
  },
  methods: {
    getBanner() {
      this.$api.queryBanner({type: this.$constants.bannerTypes.speciality}).then(res => {
        if (![0, 200].includes(res.code)) {
          return this.$message.error(res.msg)
        }
        if (res.data[0]) {
          this.bannerImage = res.data[0].image
        }
      })
    },
    getSourceType() {
      return request({
        method: 'get',
        url: 'source/info/list',
        params:
          {
            pageNum: 1,
            pageSize: 999999,
            sourceType: this.sourceType,
            name: this.name,
          }
      }).then(res => {
        if (![0, 200].includes(res.code)) {
          return this.$message.error(res.message)
        }
        this.tabs.list = res.data || []
      })
    },

    onChangeSourceType() {
      this.name = ''
      this.getSourceType()
    },

    goDetails(row) {
      window.open(row.hrefUrl+'#toolbar=0', '_blank')
    },
    submit() {
      this.getSourceType();
    },
  },
}
</script>

<style lang="stylus">
.source-container .source-poster[show] {
  opacity: 1;
}
.source-page
  .page-search
    display flex
    justify-content center
    align-items center
    searchHeight = 50px

    .el-input
      .el-input__inner
        height: searchHeight !important;
        line-height: searchHeight !important;
        border-radius: 6px 0 0 6px;
        border: none
        font-size: 16px;
        color: #999999;
</style>
<style lang="stylus" scoped>
.page
  font-size: 15px;
  background: #F9F9F9;

  &-bd
    width BodyMaxWidth
    margin 10px auto 60px auto
    uiBlock();
    padding 32px 22px 39px 22px
    box-sizing border-box

.page-header
  width: 100%;
  height: 260px;
  position relative

  &__banner
    width 100%
    height 100%
    object-fit: cover;
    position absolute
    top 0
    left 0

  &__bd
    text-align center
    padding 52px 0 0 0
    position relative
    z-index 1
    width BodyMaxWidth
    margin 0 auto
    box-sizing border-box

.page-name
  margin 0 0 38px 0
  font-size: 50px;
  font-weight: normal;
  color: #fff;
  line-height: 48px;
  text-shadow: 0px 4px 4px rgba(121, 68, 2, 0.1);

.page-search
  display flex
  justify-content center
  align-items center
  searchHeight = 50px

  &Input
    width 558px

  .el-button
    height: searchHeight;
    line-height: searchHeight;
    padding 0 44px
    border-radius: 0 6px 6px 0;
    border: none
    background: PrimaryColor;
    font-size: 16px;
    color: #fff;

.ui-tabs /deep/ .el-tabs__item, .modify-radioGroup /deep/ .el-radio-button__inner
  font-size: 15px;
  font-weight 600

#search {
  margin-left: 80px;
  margin-top: 20px;
  margin-bottom: 10px;
}

#search .el-input--mini .el-input__inner {
  height: 40px;
}

#search [class*=el-col-] {
  float: none;
}

font {
  padding-top: 260px;
  margin-top: -160px;
}

.image-gallery {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.image-wrapper {
  flex: 0 0 15%;
  margin-top: 30px;
  margin-left: 20px;
  cursor: pointer;
}

.image-wrapper img {
  width: 100%;
  height: auto;
  display: block;
  margin-bottom: 10px; /* 图片下方的空间 */
}

.image-title {
  text-align: center;
}

</style>
